import Modal from 'react-modal';
import { connect } from 'react-redux';

import { hidePopup } from '../../actions/popup';
import styles from './Popup.module.css';

const Popup = (props) => {
  const { 
    hidePopup,
    popupData,
   } = props;

  //  console.log('===popupData', popupData);

  if (!popupData) {
  return null;
  }

  const onSuccessHandler = () => {
    popupData.onConfirm();
    hidePopup();
  };

  return (
    <Modal
      onRequestClose={hidePopup}
      className={styles.modal}
      overlayClassName={styles.overlay}
      shouldCloseOnOverlayClick
      shouldCloseOnEsc
      isOpen
    >
      <div>
        <div className={styles.header}>
          {popupData.message}
          <div className={styles.close} onClick={hidePopup} />
        </div>
        <div className={styles.body}>
          <button 
            className="green-button"
            onClick={onSuccessHandler}
          >
            Ok
          </button>
          <button 
            className="transparent-button"
            onClick={hidePopup}
          >
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  popupData: state.popup.popupData,
});

const mapDispatchToProps = {
  hidePopup
};

export default connect(mapStateToProps, mapDispatchToProps)(Popup);
